<template>
	<div
		class="component c-videos padding-y-24 bp-768:padding-y-48"
		:class="{ dark: section.dark_mode }"
		v-bind:style="{
			'background-image': 'url(' + section.backgroundImage + ') ',
		}"
	>
		<div class="row padding-x-12 ">
			<common-header
				:headline="section.headline"
				:sponsor="section.sponsor"
			/>
		</div>
		<div class="row  ">
			<div
				class="c-videos__list flex-item-1 padding-x-6   d-flex flex-wrap-wrap"
			>
				<div
					v-for="video in videos"
					:key="video.id"
					v-on:click="play_video(video)"
					class="c-videos__list--item padding-y-6 bp-768:padding-y-6 padding-x-6  width-100 bp-768:width-50  "
				>
					<template v-if="video.component_type !== 'YouTube'">
						<div
							class="c-videos__list--item-inside"
							v-bind:style="{
								'background-image':
									'url(' +
									(video.component_type === 'YouTube'
										? video.maxres && video.maxres.url
											? video.maxres.url
											: video.medium.url
										: video.poster) +
									') ',
							}"
						>
							<div class="c-videos__list--item-details">
								<div class="c-videos__list--item-play">
									<i class="sf-play-minimal"></i>
								</div>
								<div
									class="c-videos__list--item-title width-100  font-size-21 line-height-125 font-weight-bold"
								>
									{{ video.title }}
								</div>
							</div>
						</div>
					</template>
					<template v-else>
						<a
							:href="video.url"
							target="_blank"
							class="c-videos__list--item-inside"
							v-bind:style="{
								'background-image':
									'url(' +
									(video.component_type === 'YouTube'
										? video.maxres && video.maxres.url
											? video.maxres.url
											: video.medium.url
										: video.poster) +
									') ',
								display: 'block',
							}"
						>
							<div class="c-videos__list--item-details">
								<div class="c-videos__list--item-play">
									<i class="sf-play-minimal"></i>
								</div>
								<div
									class="c-videos__list--item-title width-100  font-size-21 line-height-125 font-weight-bold"
								>
									{{ video.title }}
								</div>
							</div>
						</a>
					</template>
				</div>
			</div>
		</div>
		<button
			class="s-common__button font-size-14 line-height-125 font-weight-700 margin-t-12"
			@click="load_more"
		>
			Show More
		</button>
		<VideoModal
			:key="renderKey"
			:selectedvideo="selectedVideo"
			:value="video_modal_toggled"
			v-on:input="close_video_modal(selectedVideo)"
		/>
	</div>
</template>

<script>
import SectionBase from './SectionBase';
import Axios from 'axios';
import CommonHeader from '@/components/common/CommonHeader.vue';
import VideoModal from '@/components/modal/VideoModal.vue';
import { should_use_v2_api } from '@/helpers';
import Client from '@/client';

export default {
	extends: SectionBase,
	name: 'SectionVideos',
	components: {
		CommonHeader,
		VideoModal,
	},
	data: () => ({
		videos: [],
		count: 8,
		is_loading_more: false,
		video_modal_toggled: false,
		selectedVideo: null,
		renderKey: Date.now(),
	}),
	methods: {
		load_more() {
			this.is_loading_more = true;
			this.get_videos();
		},
		play_video(video) {
			if (video.component_type !== 'YouTube') {
				this.selectedVideo = video;
				this.video_modal_toggled = true;
			}
		},
		close_video_modal(video) {
			this.video_modal_toggled = false;
			if (video.component_type === 'All Access')
				this.selectedVideo = null;
		},
		get_videos() {
			if (this.section) {
				let using_v2_api = should_use_v2_api();

				let video_source = this.section.videoSource.filter(x => {
					return x.selected;
				})[0];
				if (video_source && video_source.type === 'YouTube') {
					if (using_v2_api) {
						this.fetch_youtube_videos_from_v2_api();
					} else {
						this.fetch_youtube_videos_from_legacy_api();
					}
				} else {
					let params = {
						mediaCount: this.count,
						skip: this.videos.length,
						type: 'Archive',
						category: this.section.selectedAllAccessCategory,
					};
					if (!params.category) {
						params.sport = this.$root.signing_day.sport.id;
					}

					if (using_v2_api) {
						this.fetch_all_access_media_from_v2_api(params);
					} else {
						this.fetch_all_access_media_from_legacy_api(params);
					}
				}
			}
		},
		fetch_youtube_videos_from_legacy_api() {
			Axios({
				method: 'GET',
				url: '/services/signingday.ashx?type=get-youtube',
				params: {
					youtube: this.section.selectedPlaylist,
					skip: this.videos.length,
					take: this.count,
					id: this.$root.signing_day.id,
				},
				headers: {
					'Access-Control-Allow-Origin': '*',
					'Content-type': 'application/json',
				},
			}).then(response => {
				if (response && response.data) {
					response.data.forEach(video => {
						video.component_type = 'YouTube';
					});
					this.videos = this.videos.concat(response.data);
					this.selectedVideo = response.data[0];
				}
				this.is_loading_more = false;
			});
		},
		fetch_youtube_videos_from_v2_api() {
			Client.get('/api/v2/Videos/youtube/playlist', {
				params: {
					playlistId: this.section.selectedPlaylist,
					$pageIndex: Math.ceil(this.videos.length / this.count) + 1,
					$pageSize: this.count,
				},
			}).then(response => {
				if (
					response &&
					response.data &&
					response.data.items &&
					response.data.items.length
				) {
					this.videos = this.videos.concat(
						this.map_v2_youtube_response(response.data.items),
					);
					console.log(this.videos);
					this.selectedVideo = this.videos[0];
				}
				this.is_loading_more = false;
			});
		},
		map_v2_youtube_response(videos) {
			return videos.map(x => ({
				component_type: 'YouTube',
				url: x.url,
				id: x.id,
				title: x.title,
				published_date: x.publishedDate,
				description: x.description == null ? '' : x.description,
				duration: '',
				views: 0,
				likes: 0,
				favorites: 0,
				channel: {
					id: x.channel.id,
					title: x.channel.title,
					description:
						x.channel.description == null
							? ''
							: x.channel.description,
					thumbnail:
						x.channel.thumbnail == null
							? {
									width: 0,
									height: 0,
									url: '',
							  }
							: x.channel.thumbnail,
					video_count: 0,
					subscriber_count: 0,
					view_count: 0,
				},
				default: x.thumbnails.default,
				medium: x.thumbnails.medium,
				high: x.thumbnails.high,
				standard: x.thumbnails.standard,
				maxres: x.thumbnails.maxres,
			}));
		},
		fetch_all_access_media_from_legacy_api(params) {
			Axios({
				method: 'GET',
				url: '/services/allaccess.ashx/media/get',
				params: params,
				headers: {
					'Access-Control-Allow-Origin': '*',
					'Content-type': 'application/json',
				},
			}).then(response => {
				if (response && response.data) {
					response.data.forEach(video => {
						video.component_type = 'All Access';
					});
					this.videos = this.videos.concat(response.data);
					this.selectedVideo = response.data[0];
				}
			});
		},
		fetch_all_access_media_from_v2_api(params) {
			Client.get('/api/v2/Videos/all-access/media', {
				params: params,
			}).then(response => {
				if (response && response.data && response.data.length) {
					this.videos = this.videos.concat(
						this.map_v2_all_access_response(response.data),
					);
					this.selectedVideo = this.videos[0];
				}
			});
		},
		map_v2_all_access_response(videos) {
			return videos.map(x => ({
				component_type: 'All Access',
				favorites: x.favorites,
				views: x.views,
				category_id: x.categoryId,
				duration: x.duration,
				id: x.id,
				prismId: x.prismId,
				title: x.title,
				description: x.description,
				date_utc: x.dateUtc,
				sport_id: x.sportId,
				sport_shortname: x.sportShortname,
				sport_abbreviation: x.sportAbbreviation,
				global_sport_shortname: x.globalSportShortname,
				category_name: x.categoryName,
				sport_title: x.sportTitle,
				app_exclusive: x.appExclusive,
				type: x.type,
				format: x.format,
				authorized: x.authorized,
				blackedOut: x.blackedOut,
				free: x.free,
				auth_only_required: x.authOnlyRequired,
				premium: x.premium,
				use_preroll: x.usePreroll,
				poster: x.poster,
				watchers: x.watchers,
				adTagUrl: x.adTagUrl,
				test: x.test,
			}));
		},
	},
	created() {
		this.get_videos();
	},
};
</script>

<style scoped lang="scss">
.c-videos {
	padding-bottom: 24px;
	&__list {
		margin: 12px 0 6px 0;
		&--item {
			&-play {
				width: 48px;
				height: 48px;
				display: flex;
				align-items: center;
				justify-content: center;
				background: var(--color-primary);
				font-size: 28px;
				margin: 0 0 12px 0;
			}
			&-inside {
				cursor: pointer;
				padding-bottom: 56.25%;
				height: 0;
				position: relative;
				overflow: hidden;
				border: 1px solid $main-border-color;
				border-radius: 10px;
				background-size: 100%;
				background-repeat: no-repeat;
				background-position: top center;
				transition: 0.25s;
				&:before {
					content: '';
					display: block;
					bottom: 0;
					left: 0;
					background: linear-gradient(
						180deg,
						rgba(0, 0, 0, 0) 0%,
						#000000 100%
					);
					width: 100%;
					height: 100%;
					position: absolute;
					z-index: 1;
				}
				&:hover {
					transition: 0.25s;
					background-size: 110%;
				}
			}
			&-details {
				overflow: hidden;
				position: absolute;
				color: #fff;
				bottom: 0;
				left: 0;
				width: 100%;
				height: 100%;
				z-index: 2;
				display: flex;
				flex-direction: column;
				justify-content: flex-end;
				padding: 24px;
			}
			@media screen and (max-width: 767px) {
				&-inside {
					min-height: 145px;
				}
			}
		}
	}
}
</style>
